import React, { useState, useEffect } from "react";

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../../utils/functions/getUrl";

const UploadAndDisplayImage = ({ image }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  return (
    <Container BASE_URL={BASE_URL}>+
      <input
        type="file"
        name="myImage"
        onChange={(event) => {
          // console.log(event.target.files[0]);
          console.log(event.target.files);

          // image(event.target.files[0])
          image(event.target.files)
        }}
        multiple
      />
    </Container>
  );
};

export default UploadAndDisplayImage;

const Container = styled.div `
 
  input[type="file"] {

    padding: 150px 0 0 0;
    height: 100px;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    /* background: url('https://cdn1.iconfinder.com/data/icons/hawcons/32/698394-icon-130-cloud-upload-512.png') center center no-repeat #e4e4e4; */
    background: url('${props=>props.BASE_URL}/assets/icons/add-photo-icon-19.jpg') center center no-repeat ;
    border-radius: 20px;
    background-size: 120px 120px;
  }

`;
